import { fmt } from "../lib/api";
import { useLang } from "../i18n/LanguageContext";
import { useShopSettings } from "../lib/shopSettings";

// Barre de progression vers la livraison gratuite (panier + caisse).
// Le seuil vient des paramètres admin (shipping_free_over).
export default function FreeShippingBar({ subtotal }) {
  const { t } = useLang();
  const settings = useShopSettings();
  const threshold = Number(settings.shipping_free_over) || 250;
  if (!subtotal || subtotal <= 0) return null;
  const remaining = Math.max(0, Math.round((threshold - subtotal) * 100) / 100);
  const pct = Math.min(100, Math.round((subtotal / threshold) * 100));
  return (
    <div data-testid="freeship-bar" className="mb-5">
      {remaining > 0 ? (
        <p className="text-xs text-ivory/70 mb-2" data-testid="freeship-remaining">
          {t("freeship.remaining", { amount: fmt(remaining) })}
        </p>
      ) : (
        <p className="text-xs text-gold font-semibold mb-2 flex items-center gap-1.5" data-testid="freeship-unlocked">
          {t("freeship.unlocked")}
        </p>
      )}
      <div className="h-1.5 rounded-full bg-ivory/10 overflow-hidden">
        <div
          className={`h-full rounded-full transition-[width] duration-700 ${remaining > 0 ? "bg-champagne/70" : "bg-gold"}`}
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
